import { InitialDataAggregation, SupplierCategory } from 'model';
import { AsyncThunk, EntityId } from '@reduxjs/toolkit';
import {
  createAdapterSelectors,
  createEntitySlice,
  CustomThunk
} from '../../../redux/enitySlice';
import { supplierCategoriesThunk } from './supplier-categories.thunk';
import { EntityAPI } from '../../../redux/entity-api.hook';
import { fetchInitialDataThunk } from '../../../redux/initial-data.thunk';

const { list, delete: deleteThunk, ...thunks } = supplierCategoriesThunk;

const supplierCategoriesSlice = createEntitySlice<SupplierCategory>(
  'supplier-categories',
  [
    CustomThunk.override<SupplierCategory>(list, {
      pending: (_, state) => {
        state.state = 'pending';
        state.listFetched = undefined;
        state.error = null;
        return state;
      },
      rejected: (_, state, action) => {
        state.state = 'idle';
        state.listFetched = false;
        state.error = (action as any).error;
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        state.state = 'idle';
        state.listFetched = true;
        return adapter.upsertMany(state, payload as SupplierCategory[]);
      }
    }),
    CustomThunk.override<any>(fetchInitialDataThunk, {
      pending: (_, state) => {
        return state;
      },
      rejected: (_, state) => {
        return state;
      },
      fulfilled: (adapter, state, { payload }) => {
        const dataPayload = payload as InitialDataAggregation;
        if (dataPayload.supplierCategories) {
          state.state = state.state === 'fresh' ? 'idle' : state.state;
          state.listFetched = true;
          return adapter.upsertMany(state, dataPayload.supplierCategories);
        }
        return state;
      }
    }),
    CustomThunk.override<SupplierCategory>(
      deleteThunk as AsyncThunk<EntityId, { id: EntityId }, any>,
      {
        fulfilled: (adapter, state, { payload }) => {
          state.state = 'idle';
          return adapter.removeOne(state, payload as string);
        }
      }
    ),
    ...Object.values(thunks)
  ]
);
export const supplierCategoriesSelectors = createAdapterSelectors(
  'supplier-categories',
  supplierCategoriesSlice.adapter
);

export const supplierCategoriesAPI: EntityAPI<SupplierCategory> = {
  thunks: supplierCategoriesThunk,
  selectors: supplierCategoriesSelectors
};
export default supplierCategoriesSlice;
